module.exports = __webpack_public_path__ + "img/25_45.af1b7d43.png";